"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abc = void 0;
var abc = function () {
    var controller = new AbortController();
    var signal = controller.signal;
    var abort = function () { return controller.abort(); };
    return { signal: signal, abort: abort };
};
exports.abc = abc;
//# sourceMappingURL=abortController.js.map